import React from "react";

export const Map = ({ name, address }) => {
  const formattedAddress = () => {
    return encodeURIComponent(
      `${name} ${address.address} ${address.city}, ${address.state} ${address.zipcode}`,
    );
  };

  return (
    <iframe
      title="Location Map"
      allowFullScreen
      height="400"
      width="100%"
      src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDuJAc3okKRCY6noYPEbyTeVQrWKIxIamA%20&q=${formattedAddress()}`}
    ></iframe>
  );
};
